/* Knobs.co — wizard funnel analytics (GA4).
   ─────────────────────────────────────────
   The site's GA4 (G-HC2RB775HT) is loaded through GTM, which only ships the
   default events — so the wizard funnel was invisible in analytics. This
   helper loads gtag.js in parallel against the same measurement id with
   send_page_view:false (no duplicate page_views; GA4 merges on the shared
   _ga client id) and exposes window.KWTrack for the wizard scripts.

   Loaded by sections/knobs-wizard.liquid and knobs-wizard-results.liquid
   BEFORE their main scripts. Events (all prefixed wizard_):
     wizard_start          — first step rendered with no prior progress
     wizard_step_complete  — advancing past a step  {step_id, step_index, answer}
     wizard_complete       — finished, leaving for results  {types, style, ...}
     wizard_results_view   — results page rendered  {types, style, ...}
     wizard_results_loaded — product grid rendered  {result_count}
     wizard_cta_click      — next-step click  {cta, item}
*/
(function () {
  'use strict';
  var GA_ID = 'G-HC2RB775HT';
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  if (!window.__kwGtag) {
    window.__kwGtag = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(s);
    gtag('js', new Date());
    gtag('config', GA_ID, { send_page_view: false });
  }
  window.KWTrack = function (name, params) {
    try { gtag('event', name, params || {}); } catch (e) { /* never break the wizard */ }
  };
  // User-scoped properties (e.g. wizard_completed) — GA4 keeps the latest value
  // on the user, so later purchases can be split by wizard users. Needs the
  // dimension registered in GA4 Admin → Custom definitions (scope: User).
  window.KWUser = function (props) {
    try { gtag('set', 'user_properties', props || {}); } catch (e) {}
  };
})();
